import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./services/i18n";
import { applyGeoLocale } from "./services/locale";
import { CurrencyProvider } from "./services/currency";
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import { Toaster } from 'react-hot-toast';
const root = ReactDOM.createRoot(document.getElementById('root'));

// First visit only: pick the language from the visitor's location before any content is fetched.
applyGeoLocale().finally(() => root.render(
  
  <React.Suspense fallback="Loading...">
  <BrowserRouter>
  <Provider store={store}>
  <CurrencyProvider>
  <Toaster />
    <App />
  </CurrencyProvider>
    </Provider>
    </BrowserRouter>
    </React.Suspense>

));

reportWebVitals();
